import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const workshopsApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/workshops",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/workshops",
      data,
      method: "post",
    }),
  summary: (params: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/workshops/summary",
      params,
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/workshops/" + id,
      data,
      method: "patch",
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/workshops/" + id,
      method: "delete",
    }),
  complete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/workshops/${id}/complete`,
      method: "PATCH",
    }),
};
